/**
 * exclusionService.js
 *
 * Manages exercise exclusions (PR-03).
 * Two types: "never again" (persistent) and "not today" (session-scoped).
 */

import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Add an exercise to the user's permanent exclusion list.
 * @param {string} userId - User ID
 * @param {string} exerciseId - Exercise ID to exclude
 */
export async function excludeExercise(userId, exerciseId) {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, {
    'prefs.excludedExerciseIds': arrayUnion(exerciseId),
  });
}

/**
 * Remove an exercise from the user's permanent exclusion list.
 * @param {string} userId - User ID
 * @param {string} exerciseId - Exercise ID to un-exclude
 */
export async function unexcludeExercise(userId, exerciseId) {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, {
    'prefs.excludedExerciseIds': arrayRemove(exerciseId),
  });
}

/**
 * Get the user's permanent exclusion list.
 * @param {object} prefs - User prefs object
 * @returns {string[]} Array of excluded exercise IDs
 */
export function getExcludedIds(prefs) {
  return prefs?.excludedExerciseIds || [];
}
